import { getAppointmentFetchConfigKey } from "@elixir/utils";
import useQueueStore from "../../stores/queue-store";
import { AppointmentListener } from "./apt-listener";
import { getIdb } from "../bridges/methods";
import queryClient from "../../instances/react-query-client";
import { getAppointmentLastUpdatedAtKeys } from "../../apis/idb/get-apt-last-fetch";
import dayjs from "dayjs";

let appointmentListener: AppointmentListener | null = null;

function initAptListener({
  clinicId,
  docids,
}: {
  clinicId: string;
  docids: string[];
}) {
  if (!appointmentListener) {
    appointmentListener = new AppointmentListener({
      clinicId,
      handleStatusUpdate: async ({ clinicId, date, status }) => {
        if (status === "CONNECTING") {
          //set loading status for date for the clinic
          const queueStore = useQueueStore.getState();

          const isSelectedClinic = queueStore.clinicId === clinicId;
          const isSelectedDay = dayjs(date)
            .startOf("day")
            .isSame(dayjs(queueStore.selectedDate).startOf("day"));

          if (isSelectedClinic && isSelectedDay) {
            queueStore.setIsSyncing(true);
          }
        } else if (status === "CONNECTED") {
          const fetchKey = getAppointmentFetchConfigKey({
            clinicId,
            date,
          });

          await getIdb().misc.put({
            key: fetchKey,
            lastUpdatedAt: new Date(),
          });

          queryClient.invalidateQueries(
            getAppointmentLastUpdatedAtKeys({ clinicId, date })
          );

          const queueStore = useQueueStore.getState();

          const isSelectedClinic = queueStore.clinicId === clinicId;
          const isSelectedDay = dayjs(date)
            .startOf("day")
            .isSame(dayjs(queueStore.selectedDate).startOf("day"));

          if (isSelectedClinic && isSelectedDay) {
            queueStore.setIsSyncing(false);
          }
        }
      },
      docids,
    });
  } else {
    appointmentListener.changeClinic({ clinicId });
  }
}

function changeAptListenerDate(date: Date) {
  appointmentListener?.changeDate({ date });
}

function changeAptListenerClinic(clinicId: string) {
  appointmentListener?.changeClinic({ clinicId });
}

function changeAptListenerDoctor(docids: string[]) {
  appointmentListener?.changeDoctor({ docids });
}

window.addEventListener("online", () => {
  useQueueStore.getState().setIsNetworkOnline(true);
  appointmentListener?.handlerBrowserBackOnline();
});

window.addEventListener("offline", () => {
  useQueueStore.getState().setIsNetworkOnline(false);
});

export function getAllAptSubscribers() {
  return appointmentListener?.getAllSubscribers() || [];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).getAllAptSubscribers = getAllAptSubscribers;

export {
  initAptListener,
  changeAptListenerDate,
  changeAptListenerClinic,
  changeAptListenerDoctor,
};
